module.exports = __webpack_public_path__ + "static/media/scanIconCanteen.163a040d.png";